import { render, staticRenderFns } from "./HotelDetailsDesktop.vue?vue&type=template&id=1745144b&scoped=true"
import script from "./HotelDetailsDesktop.vue?vue&type=script&lang=js"
export * from "./HotelDetailsDesktop.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailsDesktop.vue?vue&type=style&index=0&id=1745144b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1745144b",
  null
  
)

export default component.exports